/*
 * バリデーション（新規登録関連）
 */
import { isRequiredText } from '@/utils/validate/conditions';
/**
 * validation: 利用方法
 */
export const validateUseType = isRequiredText('利用方法を選択してください');
/**
 * validation: 利用規約同意
 */
export const validateAssign = (value) => value === true ? '' : '利用規約、プライバシポリシーに同意してください';
